export enum LogicFlowExecutionModeEnum {

    NORMAL,
    DEBUG,
    DRY_RUN,
}
